<script setup>
//环境碳足迹仪表板-数字护照
//质量仪表板-数字护照
import { onMounted, provide, ref, nextTick, watch } from 'vue';
import myCardCom from '../components/common/digitalPassport/myCard.vue';
import digitalPassportTable from '../components/common/digitalPassport/digitalPassportTable.vue';
import productsTable from '../components/common/productsTable.vue';
import { gethscodeByTemplate } from "@/service/apiList/productLine"
import headerCom from '../components/common/header.vue';
import { drawRadar } from "@/utils/chart.js"
import { getDashboardIndex_radar_map } from "@/service/apiList/dashboard"
import i18n from "@/i18n"
import nextIcon from "@/assets/images/products/disabled-next.png"
import prevIcon from "@/assets/images/products/disabled-prev.png"
import { getNewline } from "@/utils/common"
import myDailog from '../components/common/myDailog.vue';
import { getLangValue, formateValue } from "@/utils/common"; //获取后端语言
const colors = ['#5470c6', '#91cc75', '#3ba272', '#ee6666', '#73c0de']
// const hscodeList = ref()
const databaseList = ref([])
const showTable = ref(0)
provide('showTable', showTable)
const selectedIndex = ref(0)// 产品选中的行 index
provide('selectedIndex', selectedIndex)
const productList = ref([])// 产品列表
const selectedData = ref([]) // 选择的产品 列表
const chartData = ref({}) // 存储图表的数据
provide('selectedData', selectedData)
provide('productList', productList)
const productList_total = ref(0) // 产品总数
provide('productList_total', productList_total)
const selectedProductId = ref('') // 当前选中的产品id
provide('selectedProductId', selectedProductId)
const cardRef = ref(null) // card dom
const productsTableRef = ref(null)
const groupList = ref([]) // 存储子组数据
const activeGroup = ref('')
const digitalPassportTableRef = ref(null)
const showBtn = ref(false) // 显示左右按钮
const btnPostion = ref('left') // 按钮滚动的位置
const visible = ref(false) // 弹框图表
const optionsList = ref([]) //存储所有表信息
const title = ref('') //大图表标题
const loadingRadar = ref(false) // 雷达图加载效果
provide('loadingRadar', loadingRadar)
const getDatasBaseListList = async () => {
    // 获取模板-目标市场
    const resp = await gethscodeByTemplate()
    if (resp.code == 0) {
        if (resp.code == 0) {
            databaseList.value = resp.payload.filter(item => item.destination_market_list.length).map(item => {
                return {
                    label: item.name,
                    label_en: item.name_en,
                    value: item.name,
                    children: item.destination_market_list.map(item1 => {
                        return {
                            label: item1.title,
                            label_en: item1.title_en,
                            value: item1.id,
                            database_template_list: item1.database_template_list
                        }
                    })
                }
            })
        }
    }
}

const setChartData = (data) => {
    // 筛选没有数据的请求接口
    selectedData.value = [...data]
    if (selectedData.value.length == 0) return
    let check = false
    for (const item in data) {
        const { id, name } = data[item];
        if (Object.keys(chartData.value).length == 0 || (Object.keys(chartData.value).length > 0 && !Object.keys(chartData.value).includes(id))) {
            getRadaData(id, name)
            check = true
        }
    }
    // 展示图表
    if (!check) {
        // let index_chart = 0; // 用来标记顺序
        for (const item in chartData.value) {
            let index = selectedData.value.findIndex(item1 => item1.id == item)
            chartData.value[item].show = index > -1 ? true : false
            if (index > -1) {
                chartData.value[item].color = colors[index]
                // chartData.value[item].name = `No.${index_chart + 1}`
                // chartData.value[item].name = `No.${selectedData.value[index].number}`
                chartData.value[item].name = `No.${selectedData.value[index].number}-${selectedData.value[index].name.slice(0, 4)}`
                // index_chart++
            }

        }

        // 重新绘制图表
        showCharts()
        // 重新绘制图表
        //特殊指标
        cardRef.value.indicator_standard_list = chartData.value[selectedProductId.value].indicator_standard_list
        // 雷达图数据
        cardRef.value.drawRadarChart(chartData.value[selectedProductId.value].data)
    }

}

const serChartSeriesValue = (name) => {
    // 设置图标series 数据
    let seriesObj = [
        {
            type: 'radar',
            tooltip: {
                trigger: 'item',
            },
            radarIndex: 0,
            // areaStyle: {},
            data: []
        },
    ]
    let avgValueList = [] // 存储均值数据
    let legendData = []
    for (const item in chartData.value) {
        if (!chartData.value[item].show) continue;
        const list = chartData.value[item].data
        let arr = list.filter(item => item.name == name)

        if (arr.length) {
            let children = arr[0].children
            children.sort((a, b) => {
                // 将 name 为 "综合" 的对象排到最前面
                if (a.name === "综合" && b.name !== "综合") return -1;
                if (a.name !== "综合" && b.name === "综合") return 1;
                return 0; // 其他元素保持原始顺序
            });
            let children_value_lsit = children.map(item1 => item1.value)
            seriesObj[0].data.push({
                name: chartData.value[item].name,
                value: children_value_lsit,
                // color: chartData.value[item].color,
                // 线条颜色
                lineStyle: {
                    color: chartData.value[item].color
                },
                // 图形颜色  影响legend
                itemStyle: {
                    color: chartData.value[item].color
                },
            })
            legendData.push(chartData.value[item].name);
            // console.log(avgValueList.length);
            if (avgValueList.length == 0) {
                avgValueList = children.map(item1 => item1.avg_value)
                seriesObj[0].data.push({
                    name: getLangValue('dashboard.avg_value'),
                    value: avgValueList,
                    lineStyle: {
                        color: '#7F7F7F',
                    },
                    itemStyle: {
                        color: '#7F7F7F'
                    },
                })
                legendData.push(getLangValue('dashboard.avg_value'));
            }
        }
    }
    // 排序将均值排在最后面
    // legendData.sort((a, b) => {
    //     if (a === getLangValue('dashboard.avg_value') && b !== getLangValue('dashboard.avg_value')) return 1;
    //     if (a !== getLangValue('dashboard.avg_value') && b === getLangValue('dashboard.avg_value')) return -1;
    //     return 0; // 其他元素保持原始顺序
    // });
    const sortFunction = (a, b) => {
        if (a === getLangValue('dashboard.avg_value') && b !== getLangValue('dashboard.avg_value')) return 1;
        if (a !== getLangValue('dashboard.avg_value') && b === getLangValue('dashboard.avg_value')) return -1;

        if (a === b) return 0;
        if (a < b) return -1;
        if (a > b) return 1;
        return 0; // 其他元素保持原始顺序
    };
    legendData.sort(sortFunction);
    // 同时对series数据进行相同的排序
    seriesObj[0].data.sort((a, b) => sortFunction(a.name, b.name));
    return { seriesObj, legendData }
}

const showCharts = () => {
    activeGroup.value = 0
    // 展示图表
    optionsList.value = []
    for (const item in groupList.value) {
        let { seriesObj: data, legendData: legendData } = serChartSeriesValue(groupList.value[item].name);
        //设置三个图表
        const { children } = groupList.value[item]
        let indicatorList = children.map(item => {
            return {
                name: i18n.global.locale == 'en' ? getNewline(item.name_en, 10) : getNewline(item.name, 10),
                name1: i18n.global.locale == 'en' ? item.name_en : item.name,
                max: 1,
            }
        })
        let option = {
            // color: colors,
            tooltip: {
                trigger: 'axis',
                confine: true,
                formatter: function (params) {
                   let str = ` <div style='color: ${params.color};font-weight: bold'>${params.name}</div>`;
                    for (const item in params.value) {
                        str += `
                       
                        <div>
                        <div style='min-width:100px; text-align:left; display:inline-block'>
                            ${indicatorList[item].name1}
                        </div>
                            :
                         <div style='min-width:100px; text-align:left; display:inline-block'>${params.value[item]==null? '-': formateValue(params.value[item])}</div>
                    </div>`
                    }
                    return str
                }
            },
            legend: {
                data: legendData,
                bottom: 0,
            },
            radar: {
                indicator: indicatorList,
                radius: indicatorList.length == 2 ? 60 : 70,
                center: indicatorList.length == 2 ? ['50%', '45%'] : indicatorList.length == 3 ? ['50%', '55%'] : ['50%', '50%'],
                // 设置角标颜色和样式
                axisName: {
                    color: '#000', // 设置角标颜色
                    fontSize: 13, // 字体大小
                },
                splitLine: { //里面四个圈线条样式
                    lineStyle: {
                        color: [
                            'rgba(169,169,169, 1)',
                            'rgba(232, 236,244, 1)',
                            'rgba(232, 236,244, 1)',
                            'rgba(232, 236,244, 1)',
                            'rgba(232, 236,244, 1)',
                        ],//分别对应四个第一个对应最里面的圈
                        width: 2,
                    }
                },
                axisLine: {
                    lineStyle: {
                        color: "rgba(169,169,169, 1)",
                        width: 2, // 轴线宽度
                    }
                },
                axisLabel: {
                    show: true,
                    formatter: function (value, index) {
                        // 只在最后一个角显示最大值
                        if (index === 5) {
                            return value;
                        } else {
                            return '';
                        }
                    },
                    margin: 10,
                }
            },

            // [
            //     {
            //         indicator: indicatorList,
            //         radius: 100
            //     }
            // ],
            series: data,
        };
        optionsList.value.push({ option, indicatorList });//把图表数据存储起来
        // visible.value = true
        nextTick(() => {
            let dom = document.getElementById(`groupChart_${item}`)
            drawRadar(dom, option)
        })
    }
}

const showBigChart = (key) => {
    // 展示大图
    visible.value = true
    title.value = groupList.value[key].name ? `${getLangValue('dashboard.circularity.performance_of_pef_Indicator_Grouping')}-${i18n.global.locale == 'en' ? groupList.value[key].name_en : groupList.value[key].name}` : getLangValue('dashboard.circularity.performance_of_pef_Indicator_Grouping');
    nextTick(() => {
        let dom = document.getElementById(`myChartsRef`)
        dom.setAttribute('_echarts_instance_', '')
        let { option, indicatorList } = optionsList.value[key];
        // 修改部分信息
        option.radar.radius = 150;
        option.radar.center = ['50%', '50%'];
        // 修改名称 不需要换行了
        option.radar.indicator = indicatorList.map(item => {
            return {
                name: item.name1,
                max: item.max
            }
        });
        drawRadar(dom, option)
    })
}

const setGroupName = (data) => {
    // 设置数据
    if (data.length == 0) return
    groupList.value = data.filter(item => item.name != '综合' &&  item.name.indexOf('总体') ==-1)
    showBtn.value = groupList.value.length >= 4 ? true : false; // 显示左右切换按钮
}

const switchGroup = (key) => {
    if (activeGroup.value == key && !digitalPassportTableRef.value.noChildrengroupObj[key]) {
        // 组名是同一个而且   他还是没有子组的情况就清空  就会显示全部的指标
        digitalPassportTableRef.value.activeSubGroup = '';
    } else {
        //切换组名 
        activeGroup.value = key
    }
}

const getRadaData = async (id, name) => {
    // 获取雷达图数据
    activeGroup.value = '';
    let params = {
        category_id: 4, // 环境
        id: id,
    }
    loadingRadar.value = true;
    const resp = await getDashboardIndex_radar_map(params)
    loadingRadar.value = false;
    // card部分只显示当前选中数据的特殊指标和雷达图
    if (id === selectedProductId.value) {
        //特殊指标
        cardRef.value.indicator_standard_list = resp.payload.specific_index_standard_list
        // 雷达图数据
        cardRef.value.drawRadarChart(resp.payload.radar_map)
    }
    // 保存数据
    chartData.value[id] = { name: name + id, data: resp.payload.radar_map, indicator_standard_list: resp.payload.specific_index_standard_list }
    // 筛选一下那些数据展示
    let index_chart = 0; // 用来标记顺序  显示颜色
    for (const item in chartData.value) {
        let index = selectedData.value.findIndex(item1 => item1.id == item)
        chartData.value[item].show = index > -1 ? true : false
        if (index > -1) {
            chartData.value[item].color = colors[index_chart]
            // chartData.value[item].name = `No.${index_chart + 1}`
            // chartData.value[item].name = `No.${selectedData.value[index].number}`
            chartData.value[item].name = `No.${selectedData.value[index].number}-${selectedData.value[index].name.slice(0, 4)}`

            index_chart++
        }
    }
    // 获取组名
    setGroupName(resp.payload.radar_map)
    // 重新绘制图表
    showCharts()
    activeGroup.value = 0
}

const showInstandard = (id) => {
    //显示信息
    digitalPassportTableRef.value.selectedProductId = id
}

const isScrolledToRight = (element) => {
    //是否到达右边
    btnPostion.value = element.scrollLeft + element.clientWidth >= element.scrollWidth ? 'right' : ''
    return element.scrollLeft + element.clientWidth >= element.scrollWidth;
};

const isScrolledToLeft = (element) => {
    //是否到达左边
    btnPostion.value = element.scrollLeft === 0 ? 'left' : ''
    return element.scrollLeft === 0;
};

const prev = () => {
    //上一个
    //验证是否到达左边
    const element = document.getElementById('chart-group')
    if (isScrolledToLeft(element)) return;
    const scrollAmount = element.clientWidth * 0.3; // 滑动30% 显示上一个chart 因为我设置的宽度30%
    element.scrollTo({
        left: element.scrollLeft - scrollAmount,
        behavior: "smooth"
    });
}

const next = () => {
    //下一个
    //验证是否到达右边
    const element = document.getElementById('chart-group')
    if (isScrolledToRight(element)) return;
    const scrollAmount = element.clientWidth * 0.3; // 滑动30% 显示下一个chart 因为我设置的宽度30%
    element.scrollTo({
        left: element.scrollLeft + scrollAmount,
        behavior: "smooth"
    });
}

const sort = (val) => {
    // 排序 重新查询
    cardRef.value.sort_field = val.sortField;
    cardRef.value.order_by = val.orderBy;
}

const pageChange =(obj)=> {
    // 分页修改
    cardRef.value.searchInfo.page = obj.currentPage;
    cardRef.value.searchInfo.limit = obj.pageSize;
    cardRef.value.searchInfo.keyword = obj.keyword2;
}
const pageChange1 =(val)=> {
    // 分页修改
    productsTableRef.value.currentPage = val;
    productsTableRef.value.selectedTableData = []
}

onMounted(() => {
    // getHscodeList()
    getDatasBaseListList();
    // getRadaData()
})


watch(selectedData, (val) => {
    // console.log(val);
    if (val.length > 0) {
        document.getElementById('tableDom').style.maxHeight = 'calc(100% - 360px - 2.6rem)'
    } else {
        document.getElementById('tableDom').style.maxHeight = 'unset'
    }
}, { deep: true })

watch(activeGroup, (val) => {
    // 组名改变则显示子组名分组  否则显示全部
    digitalPassportTableRef.value.groupNameSubGroupNamekeyword = activeGroup.value === '' ? '' : groupList.value.length ? groupList.value[val].name : '';
})

watch(productList, ()=> {
    showTable.value = 0
}, {deep: true})

</script>
<template>
    <!-- 环境碳足迹dashboard -->
    <div class="environment-passport1 my-scroll-bar">
        <!-- <div class="header d-flex justify-content-between p-3 align-items-center">
            <div class="title">环境碳足迹仪表盘</div>
            <div class="home d-flex  align-items-center cursor-pointer" @click="fullScreen">
                <span>HOME</span>
                <i class="bx bx-fullscreen ms-3" v-if="!isFullScreen"></i>
                <i class="bx bx-exit-fullscreen ms-3" v-else></i>
            </div>
        </div> -->
        <headerCom :title="getLangValue('dashboard.circularity.title')" />
        <div class="main d-flex">
            <div class="left-aside  my-scroll-bar">
                <myCardCom :category="4" @search="search" ref="cardRef" :databaseList="databaseList"
                    :placeholder="getLangValue('dashboard.input1')"
                    @updatePage="pageChange1"
                    :title="getLangValue('dashboard.circularity.titleText')"
                    :title1="getLangValue('dashboard.circularity.titleText5_new')"
                    :title2="getLangValue('dashboard.circularity.special_environmental_indicators')" />
            </div>

            <div class="center mx-2 d-flex flex-column my-scroll-bar">
                <div v-if="selectedData.length" class="card px-3 py-2">
                    <div class="my-card-header">{{
                        getLangValue('dashboard.circularity.performance_of_pef_Indicator_Grouping') }}
                    </div>
                    <hr class="my-2" style="background-color:  #E9EBEC; opacity: 1;border-top: 1px solid #E9EBEC;" />
                    <!-- 图表数据 -->
                    <div class="my-group-charts d-flex justify-content-between align-items-center"
                        style="margin-top: -6px;">
                        <div style="width: 14px; display: inline-block;" v-if="showBtn && btnPostion != 'left'"
                            class="me-2">
                            <img :src="prevIcon" style="width: 16px; height: auto;" @click="prev"
                                class="cursor-pointer">
                        </div>
                        <div id="chart-group"
                            style="display: block;overflow: hidden;box-sizing: border-box; margin: 0 auto; padding: 0; white-space: nowrap; flex: 1;"
                            v-if="groupList.length">
                            <div style="display: inline-block; width: 33%;height: 300px;" class="mx-2 chart-item"
                                v-for="(item, key) in groupList" :key="key">
                                <div :id="`groupChart_${key}`" style="width: 100%; height: 280px;"
                                    @dblclick="showBigChart(key)"></div>
                                <div style="text-align: center;">
                                    <span class="cursor-pointer" :class="activeGroup == key ? 'activeGroup' : ''"
                                        @click="switchGroup(key)">{{
                                            i18n.global.locale == 'en' ? item.name_en : item.name
                                        }}</span>
                                </div>
                            </div>
                        </div>
                        <div class="d-flex align-items-center justify-content-center flex-1" style="height: 300px;" v-else></div>
                        <div style="width:14px;display: inline-block; text-align: right;"
                            v-if="showBtn && btnPostion != 'right'" class="ms-2">
                            <img :src="nextIcon" style="width: 16px; height: auto;" @click="next"
                                class="cursor-pointer">
                        </div>
                    </div>
                </div>
                <div class="card px-3 py-2" style="flex:1;border-radius: 0.55rem;" id="tableDom">
                    <div class="my-card-header">{{ showTable == 0 ?
                        getLangValue('dashboard.circularity.numerical_performance_of_environmental_indicators') :
                        getLangValue('dashboard.circularity.Performance_subgroups_in_the_climate_index_group') }}</div>
                    <hr class="my-2" style="background-color:  #E9EBEC; opacity: 1;border-top: 1px solid #E9EBEC;" />
                    <div class="my-card-content">
                        <!-- <digitalPassportTable /> -->
                        <digitalPassportTable v-show="showTable === 1" ref="digitalPassportTableRef" :category="4" />
                        <productsTable ref="productsTableRef" v-show="showTable == 0" :dashboardType="'circularity'" @showCharts="setChartData"
                            @showInstandard=showInstandard @sort="sort"  @pageChange="pageChange" />
                    </div>
                </div>
            </div>
            <!-- <div class="right-aside">
                <div class="card px-3 py-2" style="height: calc(100% - 1.3rem ) ;">
                    <myRankCard :hscodeList="hscodeList" :hscodeTopList="hscodeTopList"
                        :placeholder="getLangValue('dashboard.input1')" />
                </div>
            </div> -->
        </div>
    </div>
    <myDailog v-if="visible" v-model:visible="visible" :title="title" :width="800">
        <div style="width: 100%; height: 500px;" id="myChartsRef"></div>
    </myDailog>
</template>
<style scoped lang="scss">
.environment-passport {
    background-color: #2E404C;
    height: 100vh; //way-1
    // height: 100%; //way-2
    // overflow-y: auto; //way-2

    .header {
        height: 60px;

        .title {
            font-size: 24px;
            font-weight: 700;
            color: white;
        }

        .home {
            font-size: 20px;
            font-weight: 700;
            color: white;
        }
    }

    .main {
        height: calc(100vh - 60px); //way-1

        .left-aside {
            display: flex;
            // flex-direction: column;
            // justify-content: space-between;
            width: 500px;
            // overflow-y: auto;
            margin-bottom: 1.3rem;
            height: 100%;
        }

        .center {
            flex: 1; //way-1
            height: 100%; //way-1
            margin-bottom: 1.3rem; //way-1
            max-width: calc(100% - 500px);

            // height: auto;  //way-2
            // margin-bottom: 1.5rem; //way-2
            .card {
                background-color: #495057;
                border: 1px solid #D9D9D980;

                .my-card-header {
                    color: white;
                    font-size: 16px;
                    font-weight: 700;
                }

                .my-card-content {
                    height: calc(100% - 24px - 1rem);

                    .hscode {
                        color: #9599AD;
                        word-break: break-all;

                        .active {
                            color: white !important;
                        }
                    }

                    .search {
                        height: 38px;

                        :deep(.el-input--suffix) {
                            width: 110px;
                            height: 100%;
                        }

                        :deep(.el-input__wrapper) {
                            background-color: #4a5056;
                        }

                        :deep(.el-input__inner) {
                            color: white;
                        }

                        .form-control {
                            background-color: #4a5056;
                            color: white;
                        }
                    }
                }
            }
        }

        .right-aside {
            width: 480px;

            .card {
                background-color: #495057;
                border: 1px solid #D9D9D980;

            }
        }
    }
}

.environment-passport1 {
    // background-color: #2E404C;
    height: 100vh; //way-1
    // height: 100%; //way-2
    // overflow-y: auto; //way-2

    // .header {
    //     height: 60px;

    //     .title {
    //         font-size: 24px;
    //         font-weight: 700;
    //         color: white;
    //     }

    //     .home {
    //         font-size: 20px;
    //         font-weight: 700;
    //         color: white;
    //     }
    // }

    .main {
        height: calc(100vh - 60px); //way-1

        .left-aside {
            display: flex;
            // flex-direction: column;
            // justify-content: space-between;
            width: 500px;
            // overflow-y: auto;
            margin-bottom: 1.3rem;
            height: 100%;
        }

        .center {
            flex: 1; //way-1
            height: 100%; //way-1
            margin-bottom: 1.3rem; //way-1
            max-width: calc(100% - 500px);

            // height: auto;  //way-2
            // margin-bottom: 1.5rem; //way-2
            .card {
                // background-color: #495057;
                border: 1px solid #D9D9D980;

                .my-card-header {
                    color: #212529;
                    font-size: 16px;
                    font-weight: 700;
                }

                .my-card-content {
                    height: calc(100% - 24px - 1rem);

                    .hscode {
                        color: #9599AD;
                        word-break: break-all;

                        .active {
                            color: white !important;
                        }
                    }

                    .search {
                        height: 38px;

                        :deep(.el-input--suffix) {
                            width: 110px;
                            height: 100%;
                        }

                        :deep(.el-input__wrapper) {
                            // background-color: #4a5056;
                        }

                        :deep(.el-input__inner) {
                            color: #212529;
                        }

                        .form-control {
                            // background-color: #4a5056;
                            color: #212529;
                        }
                    }
                }
            }

            .activeGroup {
                color: #0AB39C;
                text-decoration: underline;
            }
        }

        .right-aside {
            width: 480px;

            .card {
                background-color: #495057;
                border: 1px solid #D9D9D980;

            }
        }

        #chart-group .chart-item {
            border-right: 1px solid #D9D9D980;

            &:last-child {
                border-right: none;
            }
        }
    }
}
</style>
